import { Component, input } from '@angular/core';
import { DiffLine } from '../configuration-view';

@Component({
  selector: 'app-diff-view',
  styleUrl: './diff-view.scss',
  template: `<pre>@for (line of lines(); track $index) {<span class="diff-line"><span class="line-no" aria-hidden="true" [class.removed]="line.changed && tone() === 'removed'" [class.added]="line.changed && tone() === 'added'">{{ $index + 1 }}</span><span class="line-text" [class.changed]="line.changed && tone() === 'changed'" [class.removed]="line.changed && tone() === 'removed'" [class.added]="line.changed && tone() === 'added'">{{ line.text }}</span></span>}</pre>`,
})
export class DiffView {
  readonly lines = input.required<DiffLine[]>();
  readonly tone = input<'changed' | 'removed' | 'added'>('changed');
}
